import { createContext } from 'react';
const defaultValue = {
  email: '',
  availableLogins: [],
  loginRequirementPortalId: undefined,
  additionalSsoPortal: undefined,
  isEmailSet: false,
  isFbSignin: false,
  isLoaded: false,
  onClickChangeEmail: () => {},
  onClickNext: () => {},
  onPasswordSubmit: () => {},
  password: '',
  rememberLogin: false,
  sessionInvalidationWarning: undefined,
  setEmail: () => {},
  setIsEmailSet: () => {},
  setIsLoaded: () => {},
  setPassword: () => {},
  setError: () => {},
  submittable: true,
  submitting: false,
  toggleRememberLogin: () => {},
  useDark: false,
  pageId: '',
  isBypassChecked: false
};
export const SmartLoginLandingPageContext = /*#__PURE__*/createContext(defaultValue);